SupportEmailFormIntlMainView = require('../../email_form/INTL/main_view')
SharedFooterIntlMainView = require('../../../../../shared/frontend/views/footer/INTL/main_view')
SharedFooterIntlPhoneNumberView = require('../../../../../shared/frontend/views/footer/INTL/phone_number_view')
SupportV1StepThreeBaseView = require('../v1_base_view')
EmailFormOptimizedContactChannelView = require('../../email_form/common/optimized_contact_channel_view')
SupportEmailFormIntlFlexibleContactChannelsView = require('../../email_form/INTL/flexible_contact_channels')
SharedIntlFooterTemplate = require('../../../../../shared/intl_footer.html.mustache')

class SupportV1INTLStepThreeView extends SupportV1StepThreeBaseView

  shouldShowContactChannelView:()->
    (window.evaluate(experiments?.showOptimizedContactChannel) or window.evaluate(window.experiments?.showFlexibleContactChannels)) and not window.priorityViewsEnabled()

  getEmailFormView: (options) ->
     new SupportEmailFormIntlMainView(options)

  renderPhoneNumberView: ->
    propagateEventBeforeReplacingElements( () =>
      phoneNumberView = new SharedFooterIntlPhoneNumberView({
        emailFormModel: @emailFormModel
        renderPopup: true
      })
      phoneNumberView.render()
    )

  configureContactChannelView: (options) ->
    if @isFlexibleContactEnabled()
      new SupportEmailFormIntlFlexibleContactChannelsView(options)
    else
      new EmailFormOptimizedContactChannelView(options)

  renderEmailForm: () ->
    @renderFooter()
    SupportV1StepThreeBaseView::renderEmailForm.apply(this, arguments)

  renderFooter:() ->
    @footerContainer = $("#footer-content")
    @phoneViewFooter = new SharedFooterIntlMainView
      template: SharedIntlFooterTemplate
      model: @emailFormModel
    @phoneViewFooter.render()
    @footerContainer.html(@phoneViewFooter.el)
    toggleCallUs(Groupon.Support.CURRENTVIEW.id)

module.exports = SupportV1INTLStepThreeView
